<template>
  <q-chip
    square
    v-bind="$attrs"
    :color="solid ? 'primary' : undefined"
    :text-color="textColor"
    :size="size"
    :style="backgroundStyle"
    :dense="dense"
    :clickable="clickable"
    :class="showingBadge.class"
    :aria-label="forceIcon || showingBadge.type === 'icon' ? ariaLabel : undefined"
    @click="event => $emit('click', event)"
  >
    <template v-if="((forceFull && (showingBadge.iconName && showingBadge.iconImage)) || forceIcon || showingBadge.type === 'icon' || showingBadge.type === 'name-and-icon') && !displayTitleOnButton">
      <q-icon
        v-if="showingBadge.iconName"
        :name="showingBadge.iconName"
        :color="!!color ? color : textColor"
        class="q-chip__icon material-icons q-icon notranslate"
        :class="{ 'q-chip__icon--left': showingBadge.type === 'name-and-icon' && !forceIcon }"
        @click="clickable ? undefined : (showToolTip = !showToolTip)"
      />
      <img
        v-else-if="showingBadge.iconImage"
        :src="showingBadge.iconImageUrl"
        :style="{
          'height': imageHeight,
          'filter': lightImage ? 'brightness(0) invert(1)' : undefined,
        }"
        style="width: auto;"
        :alt="showingBadge.displayName"
      >
    </template>
    <div
      v-if="!forceIcon && (forceFull || showingBadge.type === 'name' || showingBadge.type === 'name-and-icon') && !displayTitleOnButton"
      class="q-chip__content col row no-wrap items-center q-anchor--skip"
      :style="{ 'max-width': !!badgeNameMaxWidth ? badgeNameMaxWidth : undefined }"
      @click="clickable ? undefined : (showToolTip = !showToolTip)"
    >
      <div class="ellipsis">
        {{ showingBadge.displayName }}
      </div>
    </div>
    <div
      v-if="displayTitleOnButton"
      class="q-chip__content col row items-center q-anchor--skip"
      @click="clickable ? undefined : (showToolTip = !showToolTip)"
    >
      <div
        class="ellipsis-2-lines"
        :class="{ 'text-left': textLeft }"
        style="white-space: normal; line-height: 1.2;"
      >
        {{ showingBadge.title }}
      </div>
    </div>
    <q-tooltip
      v-model="showToolTip"
      class="text-white"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div
        v-if="!displayTitleOnButton"
        class="text-h6"
      >
        {{ showingBadge.title }}
      </div>
      <div class="text-body2">
        {{ showingBadge.description }}
      </div>
    </q-tooltip>
  </q-chip>
</template>

<script>

export default {
  name: 'ShowingBadge',
  props: {
    showingBadge: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'sm'
    },
    forceFull: {
      type: Boolean,
      required: false,
      default: false
    },
    forceIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    },
    solid: {
      type: Boolean,
      required: false,
      default: false
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: null
    },
    textLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    displayTitleOnButton: {
      type: Boolean,
      required: false,
      default: false
    },
    badgeNameMaxWidth: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['click'],
  data () {
    return {
      showToolTip: false
    }
  },
  computed: {
    backgroundStyle () {
      if (this.solid) return undefined
      return 'background-color: rgba(0, 0, 0, 0.5)'
    },
    textColor () {
      if (this.color) return this.color
      return this.solid
        ? 'white'
        : 'dark'
    },
    imageHeight () {
      if (this.size === 'xs') return '4px'
      if (this.size === 'sm') return '8px'
      if (this.size === 'md') return '12px'
      if (this.size === 'lg') return '16px'
      if (this.size === 'xl') return '20px'
      return this.size
    },
    lightImage () {
      if (this.textColor) {
        return this.textColor === 'white'
      } else {
        return !!this.$q.dark.isActive
      }
    },
    ariaLabel () {
      const parts = []

      parts.push(this.showingBadge.title)

      // Add description if it exists and provides additional context
      if (this.showingBadge.description) {
        parts.push(this.showingBadge.description)
      }

      return parts.join('. ')
    }
  }
}

</script>
